export const BODY_COLOR = '#f9f9f9';
export const BORDER_COLOR = '#e1e1e1';
